module.exports = __webpack_public_path__ + "img/volleyball.31f1263b.svg";